/**
 * Google Ads Conversion Tracking
 * Fires on WhatsApp/Telegram button clicks
 */
export const trackConversion = (type, productName = null) => {
  if (typeof window.gtag !== "function") return;

  window.gtag("event", "conversion", {
    send_to: "AW-16650357724/xm8oCM7s5ZAcENyXwYM-",
    value: 200.0,
    currency: "USD",
  });
};
